import { EntityId } from "@reduxjs/toolkit"
import React from "react"
import { CloudImage } from "../../CloudProviderTypes"
import CloudImageBrowserGrid from "./CloudImageBrowserGrid"
import CloudImageBrowserImage from "./CloudImageBrowserImage"

interface Props {
  images: CloudImage[]
  onImageSelect: (image: EntityId) => void
  selectedImageIds: EntityId[]
  imageComponent?: React.FC<{
    image: CloudImage
    isSelected: boolean
    onImageSelect: (image: EntityId) => void
  }>
}

const CloudImageBrowser: React.FC<Props> = ({
  images,
  onImageSelect,
  selectedImageIds,
  imageComponent,
}) => {
  return (
    <CloudImageBrowserGrid>
      {images.map(image => {
        const isSelected = selectedImageIds.find(
          selectedImageId => selectedImageId === image.id
        )

        const ImageComponent = imageComponent || CloudImageBrowserImage

        return (
          <ImageComponent
            key={image.id}
            image={image}
            isSelected={Boolean(isSelected)}
            onImageSelect={onImageSelect}
          />
        )
      })}
    </CloudImageBrowserGrid>
  )
}

export default CloudImageBrowser
